module.exports = __webpack_public_path__ + "img/woman-full.98602519.svg";